import React, { memo, useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Country } from "country-state-city";
import { Link, NavLink } from "react-router-dom"
import { GoogleMap, MarkerF, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import ApiService from '../../services/ApiService';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { push, ref, serverTimestamp, set, onValue, off, get } from "firebase/database";
import { firebase_db } from '../../FirebaseSetup';
import "./FindMatch.css";
import { newRoomIdGet } from '../../CommonFunc';
import PreLoader from '../PreLoader';
import moment from 'moment';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { ThreeDots } from 'react-loader-spinner';
import { useQuery } from '@tanstack/react-query';


const mapStyles = {
    height: '100%',
    width: '100%',
};

const getFlagEmoji = (countryCode) => {
    if (!countryCode) return "🏳️";
    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
};



function Index() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { userData } = useSelector(state => state.auth);


    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY
    })

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [map, setMap] = useState(null)


    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [SearchModal, setSearchModal] = useState(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [SearchUserKeyWord, setSearchUserKeyWord] = useState("");
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [SearchUser, setSearchUser] = useState([]);
    const [liveUsers, setLiveUsers] = useState([]);
    const [liveUsersModalVisible, setLiveUsersModalVisible] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [VisibilityModal, setVisibilityModal] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [FilterModal, setFilterModal] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [countries, setCountries] = useState([]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [mapZoom, setmapZoom] = useState(7);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [Filter, setFilter] = useState({
        find_mode: 'manual', // 'automatic','manual'
        visibility_mode: 'global', // 'local','global'
        age: "",
        marital: "",
        occupation: "",
        bodyType: ""
    });

    const ageOptions = [];
    for (let i = 18; i <= 100; i++) {
        ageOptions.push(i);
    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onLoad = useCallback(function callback(map) {


        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        // const bounds = new window.google.maps.LatLngBounds({
        //     lat: Number(userData.latitude),
        //     lng: Number(userData.longitude),
        // });
        // map.fitBounds(bounds);

        const bounds = new window.google.maps.LatLngBounds({
            lat: Number(userData.latitude),
            lng: Number(userData.longitude),
        });

        map.fitBounds(bounds);

        //  alert(map.getZoom())
        // map.setZoom(10);

        setMap(map)
    }, [userData.latitude, userData.longitude])



    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onUnmount = useCallback(function callback(map) {
        setMap(null)
    }, [])

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [selectedMarker, setSelectedMarker] = useState(null);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [MatchUserLocation, setMatchUserLocation] = useState([]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [AutoMatchUserLocation, setAutoMatchUserLocation] = useState([]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [onlineUsers, setOnlineUsers] = useState({});

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const users = [
            ...(Filter.find_mode === "automatic" ? AutoMatchUserLocation : MatchUserLocation),
            ...SearchUser
        ];
        if (!users || users.length === 0) return;

        const unsubscribes = users.map(user => {
            const statusRef = ref(firebase_db, `/status/${user.id}`);
            return onValue(statusRef, (snapshot) => {
                if (snapshot.exists()) {
                    const val = snapshot.val();
                    setOnlineUsers(prev => ({ ...prev, [user.id]: val?.state === "online" }));
                } else {
                    setOnlineUsers(prev => ({ ...prev, [user.id]: false }));
                }
            });
        });

        return () => {
            unsubscribes.forEach(unsub => unsub());
        };
    }, [AutoMatchUserLocation, MatchUserLocation, Filter.find_mode, SearchUser]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = useNavigate();

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const location = useLocation();

    // eslint-disable-next-line react-hooks/rules-of-hooks, no-unused-vars
    const [Loader, setLoader] = useState(false);

    // eslint-disable-next-line react-hooks/rules-of-hooks, no-unused-vars
    const [AgeError, setAgeError] = useState("");

    // eslint-disable-next-line react-hooks/rules-of-hooks, no-unused-vars
    const [CallChargeData, setCallChargeData] = useState({});

    const [AutomaticModalOpen, setAutomaticModalOpen] = useState(false);

    const [FilterLoader, setFilterLoader] = useState(false);

    const [FilterReset, setFilterReset] = useState(false);

    const [SelectedCountry, setSelectedCountry] = useState(null);

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);

    const ChooseCountry = (data) => {
        setSelectedCountry(data);

        // console.log(data)

        setFilter((pre) => ({
            ...pre,
            ["visibility_mode"]: data.value
        }));
    }



    const handleMarkerClick = (marker) => {
        setmapZoom(5);
        console.log("select marker ", marker)
        const { miles, feet } = convertKilometersToMilesAndFeet(marker.distance);
        marker.miles = miles;
        marker.feet = feet;
        setSelectedMarker(marker);
    };

    const handleCloseInfoWindow = () => {
        setSelectedMarker(null);
        setmapZoom(7);
    };


    const matchPreferenceFilter = (key_name, key_value) => {
        // alert(key_value);

        setFilter((pre) => ({
            ...pre,
            [key_name]: key_value
        }));
    }

    const matchPreferenceFilterReset = () => {
        // alert(key_value);
        setSelectedCountry(null);

        setFilter((pre) => ({
            find_mode: 'manual',
            visibility_mode: 'global',
            age: "",
            marital: "",
            occupation: "",
            bodyType: ""
        }));

        setFilterReset(true);

    }

    const CallChargesDataGet = async () => {

        /////////////////// Api call ///////////////////////
        var callFeesResponce = await new ApiService().GET(`/get-all-fees`);
        console.log("get-all-fees ", callFeesResponce.data);


        if (callFeesResponce.data.status === "1") {
            setCallChargeData(callFeesResponce.data.data)
        } else {
            setCallChargeData({});
        }
    }


    const matchPreferenceList = useCallback(async (pageNum = 1, isLoadMore = false) => {
        if (isLoadMore) {
            setLoadingMore(true);
        } else {
            setFilterLoader(true);
            setPage(1);
            setHasMore(true);
        }

        console.log("Filter ", Filter, "Page ", pageNum);

        var filterData = {
            ...Filter,
            userid: userData.id,
            page: pageNum,
            limit: 10
        };

        try {
            /////////////////// Api call ///////////////////////
            var responce = await new ApiService().POST("/match-preference-list", filterData);

            if (responce.data.status === '1') {
                console.log("matchPreferenceList: ", responce.data)
                const newUsers = responce.data.userdetails || [];

                if (newUsers.length < filterData.limit) {
                    setHasMore(false);
                }

                if (Filter.find_mode === "automatic") {
                    setAutoMatchUserLocation(prev => isLoadMore ? [...prev, ...newUsers] : newUsers);
                    setMatchUserLocation([]);
                } else {
                    setMatchUserLocation(prev => isLoadMore ? [...prev, ...newUsers] : newUsers);
                    setAutoMatchUserLocation([]);
                }

                if (isLoadMore) {
                    setPage(pageNum);
                }
            }
            else if (responce.data.status === '2') {
                setHasMore(false);
                if (!isLoadMore) {
                    setMatchUserLocation([]);
                    setAutoMatchUserLocation([]);
                }
            }
            else {
                console.error(responce.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setFilterLoader(false);
            setLoadingMore(false);
            setFilterReset(false);
            setVisibilityModal(false);
            setFilterModal(false);
        }

        if (Filter.find_mode === "automatic") {
            setAutomaticModalOpen(true);
        } else {
            setAutomaticModalOpen(false);
        }

    }, [Filter, userData.id]);


    const AutomatiocModalClose = useCallback(async (find_mode) => {

        setFilterLoader(true);

        console.log("Filter ", Filter);

        var filterData = Filter;
        filterData.userid = userData.id;
        filterData.find_mode = find_mode;

        /////////////////// Api call ///////////////////////
        var responce = await new ApiService().POST("/match-preference-list", filterData);

        if (responce.data.status === '1') {
            console.log("matchPreferenceList: ", responce.data)

            if (Filter.find_mode === "automatic") {
                setAutoMatchUserLocation(responce.data.userdetails);
                setMatchUserLocation([])
            } else {
                setMatchUserLocation(responce.data.userdetails);
                setAutoMatchUserLocation([]);
            }
        }
        else if (responce.data.status === '2') {
            // toast.warning(responce.data.message);
            setMatchUserLocation([]);
            setAutoMatchUserLocation([]);
        }
        else {
            console.error(responce.data);
        }


        if (Filter.find_mode === "automatic") {
            setAutomaticModalOpen(true);
        } else {
            setAutomaticModalOpen(false);
        }

        setFilterLoader(false);
        setFilterReset(false);
        setVisibilityModal(false);
        setFilterModal(false);

    }, [Filter, userData.id, AutomaticModalOpen, FilterLoader, VisibilityModal, FilterModal, AutoMatchUserLocation]);



    const searchProfile = async (data) => {

        data = data.trim();
        setSearchUserKeyWord(data);

        console.log("setSearchUserKeyWord ", data);

        if (data === "") {
            setSearchUser([]);
            return;
        }


        var filterData = {
            userid: userData.id,
            search: data,
        }


        /////////////////// Api call ///////////////////////
        var responce = await new ApiService().POST("/search-profile", filterData);

        if (responce.data.status === '1') {
            console.log("search-profile: ", responce.data)

            setSearchUser(responce.data.userdetails);
        }
        else if (responce.data.status === '2') {
            // toast.warning(responce.data.message);
            setSearchUser([]);
        }
        else {
            console.error(responce.data);
            setSearchUser([]);
        }


    };



    const convertKilometersToMilesAndFeet = (kilometers) => {
        const miles = kilometers * 0.621371; // 1 kilometer is approximately 0.621371 miles
        const feet = miles * 5280; // 1 mile is 5280 feet

        const milesPart = Math.floor(miles);
        const feetPart = Math.round(feet % 5280);

        return {
            miles: milesPart,
            feet: feetPart,
        };
    };


    // const EnterChatORrequestSend = async () => {

    //     ////////////////// Check chat plan have /////////////
    //     /////////////////// Api call ///////////////////////
    //     var response = await new ApiService().GET(`/check-user-chat-plan-status/${userData.id}`);
    //     console.log("check-user-chat-plan-status ", response.data);

    //     if (response.data.status !== '1') {
    //         toast.warning("Please Buy Chat Plan");
    //         navigate("/profile");
    //         return;
    //     }

    //     /////////////////// Api call ///////////////////////
    //     var responce = await new ApiService().GET(`/get-chat-request?sender_id=${userData.id}&receiver_id=${selectedMarker.id}`);

    //     if (responce.data.status === '1') {
    //         navigate("/chat", {
    //             state: {
    //                 receiver_id: selectedMarker.id,
    //             }
    //         });
    //     } else {

    //         //  ===== Get a key for a new Post. ===== //
    //         // const newPostKey = push(ref(firebase_db)).key;
    //         // console.log(newPostKey)

    //         var roomId = await newRoomIdGet();

    //         set(ref(firebase_db, `/chatrooms/${roomId}`), {
    //             key: roomId,
    //             sender_id: userData.id,
    //             receiver_id: selectedMarker.id,
    //             created_at: serverTimestamp(),
    //             status: "pending", // 'pending', 'accept', 'reject'
    //             messages: []
    //         });

    //         let new_data = {
    //             room_id: roomId,
    //             sender_id: userData.id,
    //             receiver_id: selectedMarker.id,
    //             status: "pending"
    //         }

    //         /////////////////// Api call ///////////////////////
    //         var responce = await new ApiService().POST(`/add-chat-request`, new_data);

    //         if (responce.data.status === '1') {
    //             navigate("/chat", {
    //                 state: {
    //                     receiver_id: selectedMarker.id,
    //                 }
    //             });
    //         }

    //     }
    // }


    const fetchCountries = () => {
        const countryList = Country.getAllCountries();
        // console.log(JSON.stringify(countryList));
        // setCountries(countryList);

        const options = countryList.map(item => ({ value: item.isoCode, label: item.name }));

        setCountries(options);
    };



    ///////////// chat,audio and video call ////////////////////////
    const CheckCallSendOrNot = async (call_type) => {

        /////////////////// Api call ///////////////////////
        var callFeesResponce = await new ApiService().GET(`/get-all-fees`);
        console.log("get-all-fees ", callFeesResponce.data);

        let fees = 0;

        if (call_type === "audiocall") {
            fees = Number(callFeesResponce.data.data.audiocall.charges);
        }
        else if (call_type === "videocall") {
            fees = Number(callFeesResponce.data.data.videocall.charges);
        }

        let ratePerMinute = fees;

        let sender_amount = Number(userData.wallet_amount);
        let receiver_amount = Number(selectedMarker.wallet_amount);

        ///// Calculate the sender total minutes ////
        let senderTotalMinutes = Math.round(sender_amount / ratePerMinute);

        ///// Calculate the receiver total minutes ////
        let receiverTotalMinutes = Math.round(receiver_amount / ratePerMinute);

        ////// sender check have minium 5 minutes balance ////
        if (senderTotalMinutes < 5) {
            toast.warning("You don't have sufficient balance to call")
            return false;
        }
        ////// receiver check have minium 1 minutes balance ////
        else if (receiverTotalMinutes < 1) {
            toast.warning("This user unable to take your call")
            return false;
        }

        return true;
    }

    const CalculateTotalCallMinutes = async (call_type) => {

        /////////////////// Api call ///////////////////////
        var callFeesResponce = await new ApiService().GET(`/get-all-fees`);
        console.log("get-all-fees ", callFeesResponce.data);

        let fees = 0;

        if (call_type === "audiocall") {
            fees = Number(callFeesResponce.data.data.audiocall.charges);
        }
        else if (call_type === "videocall") {
            fees = Number(callFeesResponce.data.data.videocall.charges);
        }

        let sender_amount = Number(userData.wallet_amount);
        let receiver_amount = Number(selectedMarker.wallet_amount);
        let ratePerMinute = fees;

        var amount = 0;

        ///// compare which amount small or equal ///
        if (sender_amount === receiver_amount) {
            amount = sender_amount;
        } else {

            if (sender_amount < receiver_amount) {
                amount = sender_amount;
            }
            else if (receiver_amount < sender_amount) {
                amount = receiver_amount;
            }

        }

        ///// Calculate the total minutes ////
        const totalSeconds = ((Math.round(amount / ratePerMinute)) * 60);

        // console.log("totalSeconds ", totalSeconds)

        return {
            sender_amount,
            receiver_amount,
            totalSeconds,
            ratePerMinute,
        }

    }

    const EnterChatORrequestSend = async () => {

        ////////////////// Check chat plan have /////////////
        /////////////////// Api call ///////////////////////
        var response = await new ApiService().GET(`/check-user-chat-plan-status/${userData.id}`);
        console.log("check-user-chat-plan-status ", response.data);

        if (response.data.status !== '1') {
            toast.warning("Please Buy Chat Plan");
            navigate("/profile");
            return;
        }

        /////////////////// Api call ///////////////////////
        var responce = await new ApiService().GET(`/get-chat-request?sender_id=${userData.id}&receiver_id=${selectedMarker.id}`);

        if (responce.data.status === '1') {
            navigate("/chat", {
                state: {
                    receiver_id: selectedMarker.id,
                }
            });
        } else {

            //  ===== Get a key for a new Post. ===== //
            // const newPostKey = push(ref(firebase_db)).key;
            // console.log(newPostKey)

            var roomId = await newRoomIdGet();

            set(ref(firebase_db, `/chatrooms/${roomId}`), {
                key: roomId,
                sender_id: userData.id,
                receiver_id: selectedMarker.id,
                created_at: serverTimestamp(),
                status: "pending", // 'pending', 'accept', 'reject'
                messages: []
            });

            let new_data = {
                room_id: roomId,
                sender_id: userData.id,
                receiver_id: selectedMarker.id,
                status: "pending"
            }

            /////////////////// Api call ///////////////////////
            var responce = await new ApiService().POST(`/add-chat-request`, new_data);

            if (responce.data.status === '1') {
                navigate("/chat", {
                    state: {
                        receiver_id: selectedMarker.id,
                    }
                });
            }

        }
    }

    const EnterAudioCallRrequestSend = () => {

        Swal.fire({
            title: `Audio Call charges $${CallChargeData?.audiocall?.charges?.toFixed(2)}/min`,
            showCancelButton: true,
            confirmButtonText: "Continue",
        }).then(async (result) => {
            if (result.isConfirmed) {

                setLoader(true);
                let new_data = {
                    userid: selectedMarker.id,
                }
                /////////////////// Api call ///////////////////////
                var userBusyResponce = await new ApiService().POST(`/get-pnotify-key`, new_data);
                console.log("userBusyResponce ", userBusyResponce.data)

                if (userBusyResponce.data.status === '1') {

                    const statusSnap = await get(ref(firebase_db, `/status/${selectedMarker.id}`));
                    const isUserOnline = statusSnap.exists() && statusSnap.val()?.state === "online";
                    if (!isUserOnline) {
                        toast.warning("User offline");
                        setLoader(false);
                        return;
                    }

                    let checkCallSendOrNot = await CheckCallSendOrNot("audiocall");
                    if (!checkCallSendOrNot) {
                        setLoader(false);
                        return;
                    }

                    //  ===== Get a key for a new Post. ===== //
                    // const newPostKey = push(ref(firebase_db)).key;
                    // console.log(newPostKey)
                    var roomId = await newRoomIdGet();


                    let new_data = {
                        genkey: roomId,
                        senderid: userData.id,
                        receiverid: selectedMarker.id,
                        starttime: moment().unix(),
                        endtime: moment().add(1.1, 'minutes').unix() /// this time will be dynamic with wallet amount
                    }

                    /////////////////// Api call ///////////////////////
                    var responce = await new ApiService().POST(`/send-request`, new_data);
                    console.log("send-request ", responce.data)

                    if (responce.data.status === '1') {

                        if (responce.data.block_count > 0) {
                            toast.warning("User blocked you!");
                            setLoader(false);
                            return;
                        }


                        //////////////// Calculate total call minutes /////////////
                        var callObj = await CalculateTotalCallMinutes("audiocall");
                        console.log("callObj", callObj);


                        set(ref(firebase_db, `/user_video_audio_call_requests/${roomId}`), {
                            key: roomId,
                            sender_id: userData.id,
                            receiver_id: selectedMarker.id,
                            created_at: serverTimestamp(),
                            call_type: 'audio',
                            notificationid: responce.data.notification_id,
                            status: "pending", // 'pending','accept','reject','complete'
                            rating_status: "pending",
                            totalSeconds: callObj.totalSeconds,
                            ratePerMinute: callObj.ratePerMinute,
                            sender_details: {
                                profile_pic_pro_resize_200_url: userData.profile_pic_pro_resize_200_url,
                                name: userData.name,
                                gender: userData.gender,
                                wallet_amount: userData.wallet_amount
                            },
                            receiver_details: {
                                profile_pic_pro_resize_200_url: selectedMarker.profile_pic_pro_resize_200_url,
                                name: selectedMarker.name,
                                gender: selectedMarker.gender,
                                wallet_amount: selectedMarker.wallet_amount
                            },
                        });


                        // navigate("/audio-call", {
                        //   state: {
                        //     page_access: true,
                        //     room_id: roomId,
                        //   }
                        // });
                    } else {
                        toast.warning(responce.data.message);
                    }



                } else {
                    toast.warning(userBusyResponce.data.message);
                }
                setLoader(false);


            }
        })


    }


    const EnterVideoCallRrequestSend = () => {

        Swal.fire({
            title: `Video Call charges $${CallChargeData?.videocall?.charges?.toFixed(2)}/min`,
            showCancelButton: true,
            confirmButtonText: "Continue",
        }).then(async (result) => {
            if (result.isConfirmed) {

                setLoader(true);

                let new_data = {
                    userid: selectedMarker.id,
                }
                /////////////////// Api call ///////////////////////
                var userBusyResponce = await new ApiService().POST(`/get-pnotify-key`, new_data);
                console.log("userBusyResponce ", userBusyResponce.data)

                if (userBusyResponce.data.status === '1') {

                    const statusSnap = await get(ref(firebase_db, `/status/${selectedMarker.id}`));
                    const isUserOnline = statusSnap.exists() && statusSnap.val()?.state === "online";
                    if (!isUserOnline) {
                        toast.warning("User offline");
                        setLoader(false);
                        return;
                    }

                    let checkCallSendOrNot = await CheckCallSendOrNot("videocall");
                    if (!checkCallSendOrNot) {
                        setLoader(false);
                        return;
                    }

                    //  ===== Get a key for a new Post. ===== //
                    // const newPostKey = push(ref(firebase_db)).key;
                    // console.log(newPostKey)
                    var roomId = await newRoomIdGet();


                    let new_data = {
                        genkey: roomId,
                        senderid: userData.id,
                        receiverid: selectedMarker.id,
                        starttime: moment().unix(),
                        endtime: moment().add(1.10, 'minutes').unix() /// this time will be dynamic with wallet amount
                    }

                    /////////////////// Api call ///////////////////////
                    var responce = await new ApiService().POST(`/send-request`, new_data);
                    console.log("send-request ", responce.data)

                    if (responce.data.status === '1') {

                        if (responce.data.block_count > 0) {
                            toast.warning("User blocked you!");
                            setLoader(false);
                            return;
                        }

                        //////////////// Calculate total call minutes /////////////
                        var callObj = await CalculateTotalCallMinutes("videocall");
                        console.log("callObj", callObj);

                        set(ref(firebase_db, `/user_video_audio_call_requests/${roomId}`), {
                            key: roomId,
                            sender_id: userData.id,
                            receiver_id: selectedMarker.id,
                            created_at: serverTimestamp(),
                            call_type: 'video',
                            notificationid: responce.data.notification_id,
                            status: "pending", // 'pending','accept','reject','complete'
                            rating_status: "pending",
                            totalSeconds: callObj.totalSeconds,
                            ratePerMinute: callObj.ratePerMinute,
                            sender_details: {
                                profile_pic_pro_resize_200_url: userData.profile_pic_pro_resize_200_url,
                                name: userData.name,
                                gender: userData.gender,
                                wallet_amount: userData.wallet_amount
                            },
                            receiver_details: {
                                profile_pic_pro_resize_200_url: selectedMarker.profile_pic_pro_resize_200_url,
                                name: selectedMarker.name,
                                gender: selectedMarker.gender,
                                wallet_amount: selectedMarker.wallet_amount
                            },
                        });


                        // navigate("/audio-call", {
                        //   state: {
                        //     page_access: true,
                        //     room_id: roomId,
                        //   }
                        // });
                    } else {
                        toast.warning(responce.data.message);
                    }



                } else {
                    toast.warning(userBusyResponce.data.message);
                }

                setLoader(false);

            }
        })


    }
    ///////////// chat,audio and video call ////////////////////////


    //// notification ////
    const {
        data: notificationData = {},
    } = useQuery({
        queryKey: ['notification'],
        queryFn: async () => {
            /////////////////// Api call ///////////////////////
            var response = await new ApiService().POST(`/new-user-info`, {
                userid: userData.id,
            });
            console.log("get-all-notifications ", response.data);
            return response.data;
        },
    });


    useEffect(() => {
        const liveStreamsRef = ref(firebase_db, '/liveStreams');
        const unsubscribe = onValue(liveStreamsRef, snapshot => {
            const rawValue = snapshot.val() || {};
            const parsedLiveUsers = Object.values(rawValue)
                .filter(item => item && item.isLive && String(item.hostId) !== String(userData?.id))
                .sort((a, b) => (b.startedAt || 0) - (a.startedAt || 0));
            console.log("liveUsers list from Firebase Realtime Database: ", parsedLiveUsers);
            setLiveUsers(parsedLiveUsers);
        });

        return () => {
            unsubscribe();
        };
    }, [userData?.id]);

    useEffect(() => {
        CallChargesDataGet();
    }, [])

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        matchPreferenceList(1, false);
    }, []);

    // Infinite scroll listener
    useEffect(() => {
        const handleScroll = () => {
            if (!hasMore || loadingMore || FilterLoader) return;

            const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

            if (windowHeight + scrollTop >= documentHeight - 350) {
                const nextPage = page + 1;
                matchPreferenceList(nextPage, true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('touchmove', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('touchmove', handleScroll);
        };
    }, [page, hasMore, loadingMore, FilterLoader, matchPreferenceList]);

    useEffect(() => {
        if (FilterReset) {
            matchPreferenceList(1, false);
        }
    }, [FilterReset]);




    return (<>

        {/* ==== Loader ==== */}
        <PreLoader Loader={Loader} />
        {/* ==== Loader ==== */}

        {/* Premium Header */}
        <header className="find-match-header">
            <NavLink to="/" className="logo-link">
                <img src="/images/logo/RealTimeVillage_logo.png" onError={(e) => { e.target.src = "/images/logo.png" }} alt="WheelLucky" />
            </NavLink>
            <div className="header-actions">
                <Link
                    to="/go-live"
                    className="go-live-header-btn"
                    title="Go Live Stream"
                    state={{
                        role: 'host',
                        hostId: userData.id,
                        hostName: userData.name,
                        hostImage: userData.profile_pic_pro_resize_200_url,
                        channelName: `profile_live_${userData.id}`
                    }}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        border: '2px solid #8ABB45',
                        borderRadius: '20px',
                        padding: '6px 16px',
                        color: '#8ABB45',
                        fontWeight: '800',
                        fontSize: '11px',
                        backgroundColor: '#ffffff',
                        gap: '10px',
                        height: '42px',
                        boxSizing: 'border-box',
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        textTransform: 'uppercase'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#8ABB45';
                        e.currentTarget.style.color = '#ffffff';
                        const icon = e.currentTarget.querySelector('i');
                        if (icon) icon.style.color = '#ffffff';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#ffffff';
                        e.currentTarget.style.color = '#8ABB45';
                        const icon = e.currentTarget.querySelector('i');
                        if (icon) icon.style.color = '#8ABB45';
                    }}
                >
                    <i className="fa fa-video-camera" style={{ color: '#8ABB45', fontSize: '18px', transition: 'color 0.2s' }}></i>
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.1', textAlign: 'left', fontWeight: '900', letterSpacing: '0.5px' }}>
                        <span>GO</span>
                        <span>LIVE</span>
                    </div>
                </Link>
                <NavLink to="/profile" state={{ tab_name: 'funds' }} className="wallet-pill">
                    <img src="/images/team/Walet-icon.svg" alt="wallet" />
                    <span>$ {Number(userData.wallet_amount).toFixed(2)}</span>
                </NavLink>
                <button
                    type="button"
                    className={`action-btn ${FilterModal ? 'active' : ''}`}
                    onClick={() => {
                        matchPreferenceFilter('find_mode', 'manual');
                        setAutomaticModalOpen(false);
                        setFilterModal(true);
                        fetchCountries();
                    }}
                >
                    <i className="fa-solid fa-sliders"></i>
                </button>
                <button
                    type="button"
                    className={`action-btn ${SearchModal ? 'active' : ''}`}
                    onClick={() => {
                        matchPreferenceFilter('find_mode', 'manual');
                        setAutomaticModalOpen(false);
                        setSearchModal(true);
                    }}
                >
                    <i className="fa-solid fa-magnifying-glass"></i>
                </button>
            </div>
        </header>

        {/* 🔥 Live Streaming Carousel Row */}
        {liveUsers.length > 0 && (
            <section className="live-stream-section">
                <div className="live-stream-header">
                    <h5 className="live-stream-title">🔥 Live Streaming</h5>
                    <button type="button" className="see-all-btn" onClick={() => setLiveUsersModalVisible(true)}>See All</button>
                </div>
                <div className="live-stream-list">
                    {liveUsers.map((item, index) => (
                        <div
                            key={"live_stream_card_" + index}
                            className="live-card"
                            onClick={() => {
                                navigate('/view-profile', {
                                    state: {
                                        profile_id: item.hostId,
                                        page_show_permission: true
                                    }
                                });
                            }}
                        >
                            <div className="live-badge">
                                <div className="live-badge-dot"></div>
                                LIVE
                            </div>
                            <img src={item.profile_pic_pro_resize_200_url || (item.image ? `https://newbackend.realtimevillage.com/app-property/images/uploads/${item.image}` : "/images/step/01.png")} onError={(e) => { e.target.src = "/images/step/01.png" }} alt="" />
                            <div className="live-card-overlay">
                                <h6 className="live-card-name">{item.hostName || item.name}</h6>
                                <div className="live-card-footer">
                                    <span className="live-card-views">
                                        <i className="fa-solid fa-eye"></i> {item.viewers || item.views || 0}
                                    </span>
                                    <button type="button" className="live-join-btn">Join</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        )}

        {/* Popular Matching Profiles Grid */}
        <section className="popular-section">
            <h5 className="popular-title">
                {Filter.find_mode === "automatic" ? "🔥 Automatic Matches" : "Popular"}
            </h5>

            {/* If in automatic matching mode and list is closed, show banner */}
            {Filter.find_mode === "automatic" && (
                <div className="d-flex justify-content-between align-items-center mb-3 p-3 bg-white border rounded shadow-sm">
                    <span className="text-muted font-weight-bold" style={{ fontSize: "14px" }}>Active Filter Mode: Automatic</span>
                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={matchPreferenceFilterReset}>Reset Mode</button>
                </div>
            )}

            <div className="popular-grid">
                {(Filter.find_mode === "automatic" ? AutoMatchUserLocation : MatchUserLocation).map((item, index) => {
                    return (
                        <div
                            key={"match_card_" + index}
                            className="popular-card"
                            onClick={() => navigate('/view-profile', {
                                state: {
                                    profile_id: item.id,
                                    page_show_permission: true
                                }
                            })}
                        >
                            <img src={item.profile_pic_pro_resize_200_url} onError={(e) => { e.target.src = "/images/step/01.png" }} alt="" />
                            <div className="popular-overlay">
                                <h6 className="popular-name">{item.name}</h6>
                                <div className="popular-info">
                                    <span className={`status-dot ${(onlineUsers[item.id] !== undefined ? onlineUsers[item.id] : item.login_status === "1") ? "online" : "offline"}`}></span>
                                    <span className="popular-flag">{getFlagEmoji(item.country)}</span>
                                    <span className="popular-distance">{item.distancedata_2?.miles || 0} miles</span>
                                    <span className="popular-percentage">{item.matchpercent}%</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {loadingMore && (
                <div className="d-flex justify-content-center py-4">
                    <ThreeDots
                        visible={true}
                        height="40"
                        width="40"
                        color="#8bbc46"
                        radius="9"
                    />
                </div>
            )}

            {(Filter.find_mode === "automatic" ? AutoMatchUserLocation : MatchUserLocation).length === 0 && !loadingMore && (
                <div className="text-center py-5 bg-white rounded border mt-2">
                    <h5 className="mb-3 text-muted">No matches found.</h5>
                    <p className="text-secondary mb-4">Please adjust your search and filters to find matches nearby.</p>
                    <button
                        type="button"
                        className="btn btn-theme"
                        onClick={() => {
                            setFilterModal(true);
                            fetchCountries();
                        }}
                        style={{ backgroundColor: "#8abb45", color: "#fff", border: "none", borderRadius: "20px", padding: "8px 24px" }}
                    >
                        Adjust Filters
                    </button>
                </div>
            )}
        </section>



        {/* ///////////// Search Modal ///////////////// */}
        <Modal
            show={SearchModal}
            onHide={() => setSearchModal(false)}
            className="VisibilityModal search-modal"
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Search</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='v-m-content search-modal_content'>
                    <ul className='search-fil'>
                        <li>
                            <input type='text' placeholder='Search connection' value={SearchUserKeyWord} onChange={(e) => searchProfile(e.target.value)} />
                            <button type='button' onClick={() => searchProfile("")} ><i class="fa-solid fa-xmark"></i></button>
                        </li>

                    </ul>

                    {SearchUser.length > 0 && <div className='connection-container'>

                        {SearchUser.map((item, index) => (<>

                            <div key={"wishlist_" + index} class="connection" onClick={() => navigate('/view-profile', {
                                state: {
                                    profile_id: item.id,
                                    page_show_permission: true
                                }
                            })} style={{ cursor: "pointer" }}>
                                <img className="img-fluid" src={item.profile_pic_pro_resize_200_url} alt='' />
                                <div class="profile-info">
                                    <div class="profile-name">
                                        <span className={`status-dot ${(onlineUsers[item.id] !== undefined ? onlineUsers[item.id] : item.login_status === "1") ? "online" : "offline"}`} style={{ marginRight: "6px" }}></span>
                                        {item.name}
                                    </div>
                                    <div class="profile-distance">{item.distancedata_2.miles} miles away</div>
                                </div>
                                <div class="match-percentage">{item.matchpercent}% Match</div>
                            </div>

                        </>))}

                    </div>}

                </div>
            </Modal.Body>
        </Modal>


        {/* ///////////// Visibility Modal ///////////////// */}
        {/* <Modal
            show={VisibilityModal}
            onHide={() => setVisibilityModal(false)}
            className="VisibilityModal"
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Visibility</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='v-m-content'>
                    <ul>
                        <li>
                            <h6>Find Mode:</h6>
                            <div className='btn-wrap'>
                                <button
                                    type='button'
                                    className={`btn btn-sm ${Filter.find_mode === 'automatic' && 'btn-success'}`}
                                    onClick={() => matchPreferenceFilter('find_mode', 'automatic')} >Automatic</button>

                                <button
                                    type='button'
                                    className={`btn btn-sm ${Filter.find_mode === 'manual' && 'btn-success'}`}
                                    onClick={() => matchPreferenceFilter('find_mode', 'manual')} >Manual</button>
                            </div>
                        </li>
                        <li>
                            <h6>Visibility Mode:</h6>
                            <div className="btn-wrap">
                                <button
                                    type='button'
                                    className={`btn btn-sm ${Filter.visibility_mode !== 'local' && 'btn-success'}`}
                                    onClick={() => matchPreferenceFilter('visibility_mode', 'global')} >Global</button>

                                <button
                                    type='button'
                                    className={`btn btn-sm ${Filter.visibility_mode === 'local' && 'btn-success'}`}
                                    onClick={() => matchPreferenceFilter('visibility_mode', 'local')} >Local</button>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <ThreeDots
                    visible={FilterLoader}
                    height="60"
                    width="60"
                    color="#8bbc46"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
                <button className="button  btn-sm btn-theme full-rounded" style={{ marginRight: "6px" }} onClick={matchPreferenceList}>
                    Submit
                </button>
                <button className="button  btn-sm btn-theme full-rounded" onClick={matchPreferenceFilterReset}>
                    Reset
                </button>
            </Modal.Footer>
        </Modal> */}



        {/* ///////////// Filter Modal ///////////////// */}
        <Modal
            show={FilterModal}
            onHide={() => setFilterModal(false)}
            className="VisibilityModal filter-modal"
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="slide-exit-text">Slide down to exit</div>
                <div className="visibility-toggle-header">Visibility Mode :</div>
                <div className="visibility-toggle-container">
                    <button
                        type="button"
                        className={`toggle-btn ${Filter.visibility_mode !== 'local' ? 'active' : 'inactive'}`}
                        onClick={() => matchPreferenceFilter('visibility_mode', 'global')}
                    >
                        Global
                    </button>
                    <button
                        type="button"
                        className={`toggle-btn ${Filter.visibility_mode === 'local' ? 'active' : 'inactive'}`}
                        onClick={() => matchPreferenceFilter('visibility_mode', 'local')}
                    >
                        Local
                    </button>
                </div>

                <div className="filter-section-title">Age</div>
                <div className="filter-input-wrap">
                    <input
                        type="number"
                        placeholder="Age"
                        className="filter-text-input"
                        value={Filter.age}
                        onChange={(e) => matchPreferenceFilter('age', e.target.value)}
                        min={18}
                        max={100}
                    />
                </div>

                {Filter.visibility_mode === 'local' && (
                    <>
                        <div className="filter-section-title">Country</div>
                        <div className="filter-input-wrap">
                            <Select
                                options={countries}
                                onChange={(selectedOption) => ChooseCountry(selectedOption)}
                                value={SelectedCountry}
                                placeholder="Select Country"
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderColor: '#cccccc',
                                        borderRadius: '6px',
                                        minHeight: '38px',
                                        boxShadow: 'none',
                                        '&:hover': {
                                            borderColor: '#8abb45'
                                        }
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected ? '#8abb45' : provided.backgroundColor,
                                        '&:hover': {
                                            backgroundColor: state.isSelected ? '#8abb45' : '#f5f5f5'
                                        }
                                    })
                                }}
                            />
                        </div>
                    </>
                )}

                <div className="filter-section-title">Marital Status</div>
                <div className="custom-radio-group">
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="marital"
                            checked={Filter.marital === 'single'}
                            onChange={() => matchPreferenceFilter('marital', 'single')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Single</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="marital"
                            checked={Filter.marital === 'divorce'}
                            onChange={() => matchPreferenceFilter('marital', 'divorce')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Divorced</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="marital"
                            checked={Filter.marital === 'other'}
                            onChange={() => matchPreferenceFilter('marital', 'other')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Other</span>
                    </label>
                </div>

                <div className="filter-section-title">Occupation</div>
                <div className="custom-radio-group">
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="occupation"
                            checked={Filter.occupation === 'employed'}
                            onChange={() => matchPreferenceFilter('occupation', 'employed')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Employed</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="occupation"
                            checked={Filter.occupation === 'retired'}
                            onChange={() => matchPreferenceFilter('occupation', 'retired')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Retired</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="occupation"
                            checked={Filter.occupation === 'student'}
                            onChange={() => matchPreferenceFilter('occupation', 'student')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Student</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="occupation"
                            checked={Filter.occupation === 'self-employed'}
                            onChange={() => matchPreferenceFilter('occupation', 'self-employed')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Self-employed</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="occupation"
                            checked={Filter.occupation === 'unemployed'}
                            onChange={() => matchPreferenceFilter('occupation', 'unemployed')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Unemployed</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="occupation"
                            checked={Filter.occupation === 'other'}
                            onChange={() => matchPreferenceFilter('occupation', 'other')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Other</span>
                    </label>
                </div>

                <div className="filter-section-title">Body Type</div>
                <div className="custom-radio-group">
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="bodyType"
                            checked={Filter.bodyType === 'athletic'}
                            onChange={() => matchPreferenceFilter('bodyType', 'athletic')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Athletic</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="bodyType"
                            checked={Filter.bodyType === 'slender'}
                            onChange={() => matchPreferenceFilter('bodyType', 'slender')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Slender</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="bodyType"
                            checked={Filter.bodyType === 'petite'}
                            onChange={() => matchPreferenceFilter('bodyType', 'petite')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Petite</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="bodyType"
                            checked={Filter.bodyType === 'average'}
                            onChange={() => matchPreferenceFilter('bodyType', 'average')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Average</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="bodyType"
                            checked={Filter.bodyType === 'thick'}
                            onChange={() => matchPreferenceFilter('bodyType', 'thick')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Thick</span>
                    </label>
                    <label className="custom-radio-item">
                        <input
                            type="radio"
                            name="bodyType"
                            checked={Filter.bodyType === 'other'}
                            onChange={() => matchPreferenceFilter('bodyType', 'other')}
                        />
                        <div className="custom-radio-circle"></div>
                        <span className="custom-radio-label">Other</span>
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {FilterLoader && (
                    <ThreeDots
                        visible={true}
                        height="40"
                        width="40"
                        color="#8bbc46"
                        radius="9"
                        ariaLabel="three-dots-loading"
                    />
                )}
                <button type="button" className="filter-submit-btn" onClick={() => matchPreferenceList(1, false)}>
                    Submit
                </button>
                <button type="button" className="filter-reset-btn" onClick={matchPreferenceFilterReset}>
                    Reset
                </button>
            </Modal.Footer>
        </Modal>

        {/* ///////////// See All Live Streaming Users Modal ///////////////// */}
        <Modal
            show={liveUsersModalVisible}
            onHide={() => setLiveUsersModalVisible(false)}
            className="VisibilityModal see-all-modal"
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>🔥 Live Streaming Users</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='v-m-content see-all-modal_content'>
                    <div className='see-all-grid'>
                        {liveUsers.map((item, index) => (
                            <div
                                key={"live_user_" + index}
                                className="see-all-card"
                                onClick={() => {
                                    setLiveUsersModalVisible(false);
                                    navigate('/view-profile', {
                                        state: {
                                            profile_id: item.hostId,
                                            page_show_permission: true
                                        }
                                    });
                                }}
                            >
                                <img src={item.profile_pic_pro_resize_200_url || (item.image ? `https://newbackend.realtimevillage.com/app-property/images/uploads/${item.image}` : "/images/step/01.png")} onError={(e) => { e.target.src = "/images/step/01.png" }} alt='' />
                                <div className="live-badge">
                                    <div className="live-badge-dot"></div>
                                    LIVE
                                </div>
                                <div className="see-all-overlay">
                                    <h6 className="see-all-name">{item.hostName || item.name}</h6>
                                    <span className="see-all-views">
                                        <i className="fa-solid fa-eye"></i> {item.viewers || item.views || 0} views
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                    {liveUsers.length === 0 && (
                        <div className="text-center py-4">No active live streaming users right now.</div>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    </>)
}

export default memo(Index);